import React, { useContext } from "react";

import FilterIcon from "../../icons/filter-icon";
import SearchIcon from "../../icons/search-icon";

import lbl from "../../data/Labels.json";

import { YearContext } from "../../contexts/yearContext";

const TableSearch = ({ query, hasFilter, showFilter, filter, allStudents }) => {
  const { entryYear } = useContext(YearContext);

  const handleSubmit = (e) => {
    e.preventDefault();

    const form = e.currentTarget;
    const value = String(
      (form.elements.namedItem("keyword") && form.elements.namedItem("keyword").value) ||
        form.keyword?.value ||
        ""
    ).trim();

    if (value) {
      if (allStudents) {
        query({ keyword: value });
      } else {
        query({ keyword: value, entry_year_id: entryYear });
      }
    }
  };

  const clearFilter = ({ target }) => {
    if (!target.value) {
      if (allStudents) {
        query({ page: 1});
      }else {
        query({ page: 1, entry_year_id: entryYear });
      }
    }
  };

  return (
    <React.Fragment>
      <form className="keyword" onSubmit={(e) => handleSubmit(e)}>
        <div className="search-input">
          <input
            onChange={(e) => clearFilter(e)}
            placeholder={lbl.Search}
            maxLength={32}
            name="keyword"
            type="search"
            required
          />
          <button>
            <SearchIcon />
          </button>
        </div>
        {hasFilter && (
          <button
            onClick={() => showFilter(!filter)}
            className="filter"
            type="button"
          >
            <FilterIcon />
          </button>
        )}
      </form>
    </React.Fragment>
  );
};

export default TableSearch;
